import React, { useMemo, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';
import { menus, RUTA_PREINFORME } from '../../menu/menuJson';
import { isRutaRegistrada } from '../../menu/HelpMenuRutas';
import Title from '../../Imc/Title';
import { resolvePersonalData } from '../utils/HelpPreinforme';
import { MODULOS_MEDICION, MODULO_INICIAL } from '../constants/medicionesModulos';
import CabeceraMediciones from './mediciones/CabeceraMediciones';
import SelectorModulos from './mediciones/SelectorModulos';
import ModuloPlaceholder from './mediciones/ModuloPlaceholder';
import { PANELES_MODULO } from './mediciones/panelesModulo';
import medicionesStyles from './mediciones/medicionesStyles';

const MedicionesUser = () => {
	const { documento, idBascula, nameBascula } = useParams();
	const history = useHistory();
	const location = useLocation();
	const classes = medicionesStyles();

	const { busqueda } = location.state || {};
	const personalData = resolvePersonalData(location.state, { documento });
	const evbi = Number(idBascula);

	const [moduloId, setModuloId] = useState(MODULO_INICIAL);
	// Marca "Registrado" por módulo: solo vive en la vista (se pierde al desmontar)
	const [registrados, setRegistrados] = useState({});

	const marcarRegistrado = (id) => {
		setRegistrados((prev) => (prev[id] ? prev : { ...prev, [id]: true }));
	};

	// El acceso al preinforme existe solo si la ruta está en el menú del rol en sesión
	const puedeVerPreinforme = useMemo(() => isRutaRegistrada(menus(), RUTA_PREINFORME), []);

	const goToPreinforme = () => {
		history.push(`/mediciones/user/${nameBascula}/${idBascula}/preinforme/${documento}`, {
			busqueda: busqueda,
			nombre: location.state && location.state.nombre,
			documento: location.state && location.state.documento,
		});
	};

	const goBack = () => {
		history.push(`/mediciones/user/${idBascula}`, {
			nameBascula: nameBascula,
			busquedaState: busqueda,
		});
	};

	return (
		<Grid item xs={12} className={classes.root}>
			<br />
			<br />
			<Title>Registro de mediciones</Title>
			<CabeceraMediciones
				personalData={personalData}
				onVolver={goBack}
				onVerPreinforme={puedeVerPreinforme ? goToPreinforme : undefined}
			/>
			<Typography id="mediciones-selector-titulo" variant="h6" component="h3" className={classes.selectorTitle}>
				Módulos de valoración
			</Typography>
			<SelectorModulos
				modulos={MODULOS_MEDICION}
				seleccionado={moduloId}
				onSeleccionar={setModuloId}
				labelledBy="mediciones-selector-titulo"
				registrados={registrados}
			/>
			{MODULOS_MEDICION.map((modulo) => {
				const Panel = PANELES_MODULO[modulo.id] || ModuloPlaceholder;
				return (
					<div
						key={modulo.id}
						role="tabpanel"
						id={`modulo-panel-${modulo.id}`}
						aria-labelledby={`modulo-tab-${modulo.id}`}
						hidden={modulo.id !== moduloId}
						className={classes.panelArea}
					>
						<Panel modulo={modulo} numeroDocumento={documento} evbi={evbi} onRegistrado={marcarRegistrado} />
					</div>
				);
			})}
		</Grid>
	);
};

export default MedicionesUser;
